import { render, staticRenderFns } from "./campaign-detail.vue?vue&type=template&id=493e92d0&scoped=true"
import script from "./campaign-detail.vue?vue&type=script&lang=ts"
export * from "./campaign-detail.vue?vue&type=script&lang=ts"
import style0 from "./campaign-detail.vue?vue&type=style&index=0&id=493e92d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493e92d0",
  null
  
)

export default component.exports